import React, { useEffect } from 'react'
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Button } from '../../../common';
import { useNavigationContext } from '../../../context/NavigationContext';
import { getTeamQuery } from '../../../queries/team';

const { REACT_APP_BASE_URL } = process.env;

function DashboardTeamSend(props) {
  const { data: teamData } = useQuery(getTeamQuery, { variables: { teamId: props.teamId } })
  const [isCopied, setIsCopied] = useState(false);
  const [invitationLink, setInvitationLink] = useState();

  const { setNavigationActivated } = useNavigationContext();
  useEffect(() => {
    setNavigationActivated(true);
  }, [setNavigationActivated]);

  useEffect(() => {
    setInvitationLink(`${REACT_APP_BASE_URL}/invitation/teammemberguardian/${props.associationId}/${props.teamId}/${teamData && teamData.team.decryptedTeamMemberCreationToken}`)
  }, [teamData])

  const copyInvitationLink = async () => {
    if (!invitationLink) return;

    const text = 'Hej, nu startar försäljningen av Cityhäftet och det är dags att registrera din egen shop!\n\n' +
      'Registrera dig här: ' + invitationLink +
      '\n\nFyll i dina uppgifter och för att skapa din shop. Samtidigt får du tillgång till Mina sidor, där du enkelt kan se hur försäljningen går och få användbara säljtips.';

    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (err) {
      console.error('Copy failed', err);
    }
  }

  return (
    <div id="teamshare">
      <div className="share-info">
        <div className='teammembers-invite'>
          <div className="text-suggestion-header">
            <span className="header-title">Textförslag</span>
            <span className="header-dots">⋯</span>
          </div>
          <div className="text-suggestion-content">
            <p>Hej, nu startar försäljningen av Cityhäftet och det är dags att registrera din egen shop!</p>
            <p>Registrera dig här:<br /><u>LÄNK</u></p>

            <p>Fyll i dina uppgifter och för att skapa din shop. Samtidigt får du tillgång till Mina sidor, där du enkelt kan se hur försäljningen går och få användbara säljtips.</p>
          </div>
          <Button className='primary md' onClick={copyInvitationLink}>
            {isCopied ? 'Kopierat!' : 'Kopiera text + länk'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DashboardTeamSend
